const fields = {
  config: { columns: 1 },
  fields: [
    {
      name: "phoneNumber",
      label: "Numer telefonu",
      column: 1,
      type: "phone-number",
    },
    {
      name: "email",
      label: "Email",
      column: 1,
    },
    {
      name: "name",
      label: "Imię",
      column: 1,
    },
    {
      name: "surname",
      label: "Nazwisko",
      column: 1,
    },
  ],
};

export default fields;
